import { ChangeDetectionStrategy, Component, ElementRef, Inject, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogHeaderComponent, DialogService, LoaderComponent } from '@mode/shared/ui';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { ButtonComponent, IconComponent } from '@mode/capra';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  ValidationErrors,
  ValidatorFn,
  Validators,
} from '@angular/forms';
import { NotebookSecretService } from '@mode/notebooks/domain';
import { MAT_LEGACY_DIALOG_DATA } from '@angular/material/legacy-dialog';

export const duplicateValidator = (keys: string[]): ValidatorFn => {
  return (control: AbstractControl): ValidationErrors | null => {
    return keys.includes(control.value) ? { invalidSecretKey: true } : null;
  };
};
@Component({
  standalone: true,
  imports: [
    CommonModule,
    DialogHeaderComponent,
    DragDropModule,
    IconComponent,
    ButtonComponent,
    LoaderComponent,
    ReactiveFormsModule,
  ],
  selector: 'mode-notebook-secret-modal-create',
  templateUrl: './notebook-secret-modal-create.component.html',
  styleUrls: ['../modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotebookSecretModalCreateComponent {
  @ViewChild('secretKeyInput', { static: true }) secretKeyInput: ElementRef | undefined;
  form: FormGroup;
  showPassword = false;
  get secretKey() {
    return this.form.get('secretKey');
  }
  get secretValue() {
    return this.form.get('secretValue');
  }
  get showValue() {
    return this.form.get('showValue');
  }

  constructor(
    private fb: FormBuilder,
    private dialogService: DialogService,
    private notebookSecretService: NotebookSecretService,
    @Inject(MAT_LEGACY_DIALOG_DATA)
    private data: {
      secretKeys: string[];
    }
  ) {
    this.form = this.fb.group({
      secretKey: [
        '',
        [
          Validators.required,
          Validators.maxLength(100),
          Validators.pattern(/^[a-zA-Z_][a-zA-Z0-9_]*$/), // Regex for valid python variables
          duplicateValidator(data.secretKeys),
        ],
      ],
      secretValue: ['', [Validators.required, Validators.maxLength(4096)]],
      showValue: [{ value: false, disabled: true }],
    });
    this.secretValue?.valueChanges.subscribe((value) => {
      if (value) {
        this.showValue?.enable();
      } else {
        this.showValue?.disable();
      }
    });
  }

  ngAfterViewInit() {
    this.secretKeyInput?.nativeElement.focus();
  }

  onSubmit(): void {
    if (this.form.valid) {
      const { secretKey, secretValue } = this.form.value;
      this.dialogService.closeAll();
      this.notebookSecretService.createSecret({
        key: secretKey.trim(),
        secret_value: secretValue,
      });
    }
  }
  close(): void {
    this.dialogService.closeAll();
  }
  togglePasswordVisibility(): void {
    this.showPassword = !this.showPassword;
  }
}
